import { AxiosError } from "axios";

declare const currentContextPath: string;

const URL_PARAM_LENGTH_LIMIT = 1200;
const isAuthenticationError = (errorCode: number): boolean => [401, 403].includes(errorCode);

export const getCurrentUrlWithoutContextPath = (): string => {
	const url = window.location.pathname.replace(currentContextPath, "");

	// reduce Request header length
	if (window.location.search.length > URL_PARAM_LENGTH_LIMIT) {
		return url;
	}

	return url + window.location.search;
};

export const handleAuthenticationRedirect = (error: AxiosError): void => {
	if (error.response?.status && isAuthenticationError(error.response.status)) {
        const url = (error.response?.data as { redirectUrl?: string })?.redirectUrl;
        window.location.href = url || `${currentContextPath}/my-account/sign-in/`;
	}
};

export const handleErrorWithRedirect = (axiosError: AxiosError): void => {
	if (!axiosError.config?.handleErrorWithRedirect) {
		return;
	}
	const statusCode = axiosError.response?.status;
	if (statusCode === 500) {
		window.location.replace(`${currentContextPath}/error/500/`);
	}
	if (statusCode === 404) {
		window.location.replace(`${currentContextPath}/error/404/`);
	}
};
